import { render } from "./PersonRegister.vue?vue&type=template&id=bc54c13e"
import script from "./PersonRegister.vue?vue&type=script&lang=js"
export * from "./PersonRegister.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__